import React, { Component } from 'react';
import {
	Button,
	Icon,
	Image as SemImage,
	Modal,
	Responsive
} from 'semantic-ui-react';
import 'react-html5-camera-photo/build/css/index.css';
import { Field, Form, Formik } from 'formik';
import Select from 'components/Form/Select';
import * as Yup from 'yup';
import CameraPhoto from 'jslib-html5-camera-photo';

const schemaValidation = Yup.object().shape({
	documentType: Yup.number().nullable().required('Champs requis'),
});
const isMobile = () => {
	return window.innerWidth - Responsive.onlyMobile.maxWidth < 0;
};

class TakePhotoModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			photo: null,
			showPhoto: false,
			takePicture: false,
			barcode: null,
			scannerReady: false,
			usedBarcodes: [],
			wrongBarcodeFormat: false,
			cameraStarted: false, 
			documentType: null
		};
		this.cameraPhoto = null;
		this.videoRef = React.createRef();
		this.documentTypeRef = React.createRef();
	}

	componentDidMount() {
		document.body.addEventListener('keyup', this.enterEventListener);
		this.cameraPhoto = new CameraPhoto(this.videoRef.current);
		this.startCamera();
		this.setState({documentType: this.props.documentTypeOptions ? this.props.documentTypeOptions[0].id : null})
	}

	componentWillUnmount() {
		document.body.removeEventListener('keyup', this.enterEventListener);
		this.setState({ photo: null, barcode: null, wrongBarcodeFormat: false, usedBarcodes: [],  });
		this.stopCamera();
	}

	setDocumentTypeRef(el) {
		this.documentTypeRef = el
	}

	startCamera (idealFacingMode, idealResolution) {
		this.cameraPhoto.startCamera(idealFacingMode, idealResolution)
		  .then(() => {
			  this.setState({cameraStarted :true})
			console.log('camera is started !');
		  })
		  .catch((error) => {
			console.error('Camera not started!', error);
		  });
	  }

	takePhoto () {
		const config = {
			sizeFactor: 1
		};
		let dataUri = this.cameraPhoto.getDataUri(config);
		this.setState({photo: dataUri, showPhoto: true });
	}

	stopCamera () {
		this.cameraPhoto.stopCamera()
		.then(() => {
		console.log('Camera stopped!');
		})
		.catch((error) => {
		console.log('No camera to stop!:', error);
		});
	}
	

	enterEventListener = (e) => {
		if (e.key === 'Enter') {
			if (this.state && this.state.photo === null){
				this.takePhoto();
				this.setState({ takePicture: true, showPhoto: true, });
			}
			else //Recupération dans le DOM de la valeur sélectionnée pour le type de document
				if (this.state && this.state.photo !== null && this.documentTypeRef) {
					let inputValue = String(this.documentTypeRef.childNodes[0].childNodes[1].childNodes[1].value)
					this.submitPhoto(inputValue);
				}
		}
	};

	retakePhoto = () => {
		this.setState({ photo: null, barcode: null, wrongBarcodeFormat: false, showPhoto: false, scannerReady: true  });
	};

	submitPhoto = (documentType, closeModal = false) => {
		const { photo, barcode, usedBarcodes } = this.state;
		if (barcode)
			usedBarcodes.push(barcode);
		this.props.submit(photo, barcode, documentType);
		this.setState({
			showPhoto: closeModal,				
			photo: null,
			barcode: null,
			usedBarcodes: usedBarcodes,
			wrongBarcodeFormat: false,
		});
		if (closeModal) {
			this.props.close();
		}
	};

	render() {
		const {
			open,
			close,
			documentTypeOptions,
			defaultDocumentTypeValue,
		} = this.props;
		const { photo, scannerReady, showPhoto } = this.state;

		return (
			<Formik
				initialValues={{
					documentType: defaultDocumentTypeValue,
				}}
				validationSchema={schemaValidation}
				isInitialValid={
					defaultDocumentTypeValue !== null &&
					defaultDocumentTypeValue !== undefined
				}
			>
				{({ values, validateForm, isValid, setFieldTouched, resetForm }) => {
					return (
						<Form>
							<Modal
								size='large'
								open={open}
								onClose={close}
								closeOnEscape={true}
								closeOnDimmerClick={true}
							>
								<Modal.Content>
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											maxHeight: '80vh',
											
										}}
										>
											<video
											ref={this.videoRef}
											autoPlay={true}
											height={photo ? 0 : '100%' }
											style={{margin: photo ? 0 : 'auto'}}
										
											/>
										
										{photo !== null && showPhoto && 
											<SemImage
											src={photo}
											style={{ margin:'auto', height: '100%' }}
											onContextMenu={(e) => e.preventDefault()}
											/>
										}
									</div>
								</Modal.Content>
								<Modal.Actions
									style={{ display: 'flex', justifyContent: isMobile ? 'center' : 'space-between' }}
								>
									<Button
										color='red'
										onClick={(e) => {
											if (e !== undefined) e.preventDefault();
											this.setState({ scannerReady: false });
											if (photo === null) close();
											else this.retakePhoto();
										}}
									>
										<Icon name='remove' />
										{photo === null ? 'Annuler' : 'Reprendre une photo'}
									</Button>

									{documentTypeOptions && (
										<div ref={(ref) => this.setDocumentTypeRef(ref)}>
										<Field
											component={Select}

											menuPlacement='top'
											name='documentType'
											customlabel='Veuillez sélectionner un type de document'
											placeholder='Sélectionner un type de document'
											options={documentTypeOptions.map((option) => {
												return {
													value: option.id,
													label: option.title,
												};
											})}
											required
										/>
										</div>
									)}
									{/* {!noBarCode &&
									<Message
										content={
											this.state.barcode
												? `Code-barres détecté: ${this.state.barcode}`
												: this.state.wrongBarcodeFormat
												? 'Code-barres érroné'
												: 'Aucun code-barres'
										}
										color={this.state.barcode ? 'green' : 'red'}
										compact
										size='mini'
									/>} */}
									{photo !== null && (
										<Button
											color='green'
											onClick={(e) => {
												if (e !== undefined) e.preventDefault();
												setFieldTouched('documentType');
												validateForm().then((res) => {
													if (isValid) {
														this.submitPhoto(values.documentType);
														resetForm();
													}
												});
											}}
											disabled={!scannerReady}
										>
											<Icon name={'photo'} />
											Suivant
										</Button>
									)}
									<Button
										color='green'
										onClick={(e) => {
											if (e !== undefined) e.preventDefault();
											if (photo === null) this.takePhoto();
											else {
												setFieldTouched('documentType');
												
												validateForm().then(() => {
													if (isValid) {
														this.submitPhoto(values.documentType, true);
													}
												});
											}
										}}
									>
										<Icon name={photo === null ? 'photo' : 'checkmark'} />
										{photo === null ? 'Prendre une photo' : 'Terminer'}
									</Button>
								</Modal.Actions>
							</Modal>
						</Form>
					);
				}}
			</Formik>
		);
	}
}

export default TakePhotoModal;
